import { useState } from "react";

export default id => {
  const [anchorElPopover, setAnchorElPopover] = useState(null);
  const openPopover = Boolean(anchorElPopover);
  const idPopover = openPopover ? id : undefined;

  return [anchorElPopover, setAnchorElPopover, openPopover, idPopover];
};
